import { useEffect, useState, type ReactElement } from 'react'
import { api } from './api'
import { Layout } from './components/Layout'
import { BrandMark } from './components/Brand'
import { LoginPage } from './pages/LoginPage'
import { DashboardPage } from './pages/DashboardPage'
import { CustomersPage } from './pages/CustomersPage'
import { PlansPage } from './pages/PlansPage'
import { CouponsPage } from './pages/CouponsPage'
import { FinancePage } from './pages/FinancePage'
import { ReportsPage } from './pages/ReportsPage'
import { AuditPage } from './pages/AuditPage'
import type { PageId } from './types'

const pages: PageId[] = ['painel', 'clientes', 'financeiro', 'planos', 'cupons', 'relatorios', 'auditoria']
const TAB_SESSION_KEY = 'anotacripto_admin_tab_session'

export function App() {
  const [session, setSession] = useState<'loading' | 'active' | 'guest'>('loading')
  const [page, setPageState] = useState<PageId>(() => {
    const hash = location.hash.slice(1) as PageId
    return pages.includes(hash) ? hash : 'painel'
  })
  useEffect(() => {
    if (sessionStorage.getItem(TAB_SESSION_KEY) !== 'active') {
      setSession('guest')
      return
    }

    api<{ authenticated: boolean }>('/auth/session')
      .then(result => {
        if (!result.authenticated) sessionStorage.removeItem(TAB_SESSION_KEY)
        setSession(result.authenticated ? 'active' : 'guest')
      })
      .catch(() => {
        sessionStorage.removeItem(TAB_SESSION_KEY)
        setSession('guest')
      })
  }, [])
  useEffect(() => {
    const change = () => { const hash = location.hash.slice(1) as PageId; if (pages.includes(hash)) setPageState(hash) }
    addEventListener('hashchange', change); return () => removeEventListener('hashchange', change)
  }, [])
  const setPage = (next: PageId) => { location.hash = next; setPageState(next) }
  const logout = async () => {
    sessionStorage.removeItem(TAB_SESSION_KEY)
    await api('/auth/logout', { method: 'POST' }).catch(() => undefined)
    setSession('guest')
  }
  if (session === 'loading') return <div className="splash"><BrandMark size="large"/><span className="spinner"/>Carregando ambiente administrativo…</div>
  if (session === 'guest') return <LoginPage onSuccess={() => {
    sessionStorage.setItem(TAB_SESSION_KEY, 'active')
    setSession('active')
    setPage('painel')
  }}/>
  const views: Record<PageId, ReactElement> = {
    painel: <DashboardPage/>, clientes: <CustomersPage/>, planos: <PlansPage/>, cupons: <CouponsPage/>, financeiro: <FinancePage/>, relatorios: <ReportsPage/>, auditoria: <AuditPage/>,
  }
  return <Layout page={page} setPage={setPage} logout={logout}>{views[page]}</Layout>
}
